/* Nalu mega menu: adds a one-line intro and a "Brands in X" strip to each dropdown */
(function () {
  var DATA = {
    move: {
      title: 'Move',
      desc: 'Supports, wearable infrared, compression and training tools.',
      brands: [['Bauerfeind','bauerfeind'],['Incrediwear','incrediwear-1'],['Sissel','sissel'],['FootActive','footactive'],['Hallufix','hallufix']]
    },
    restore: {
      title: 'Restore',
      desc: 'Recovery wear, massage, heat therapy and better sleep.',
      brands: [['Incrediwear','incrediwear-1'],['Sissel','sissel'],['Tend','tend'],['Bauerfeind','bauerfeind']]
    },
    brands: {
      title: 'Brands',
      desc: 'The brands we trust, each chosen for quality and integrity.',
      brands: []
    },
    thrive: {
      title: 'Thrive',
      desc: 'Natural skincare, mānuka honey, teas and everyday essentials.',
      brands: [['The True Honey Co.','the-true-honey-co'],['Earthbound Organics','earthbound-organics'],['Badger Balm','badger-balm'],['Folk Soap','folk-soap'],['Nuditea','nuditea'],['Klean Kanteen','klean-kanteen'],['Nuasan','nuasan']]
    }
  };

  function pillarFor(el) {
    var d = el.closest('details');
    var s = d && d.querySelector('summary[data-link]');
    var link = (s && s.getAttribute('data-link')) || '';
    if (/\/pages\/brands\b/.test(link)) return 'brands';
    var m = link.match(/\/collections\/(move|restore|thrive)\b/);
    return m ? m[1] : null;
  }

  function esc(t) { var x = document.createElement('span'); x.textContent = t; return x.innerHTML; }

  function enhance(nav) {
    if (nav.dataset.naluDone) return;
    var key = pillarFor(nav);
    if (!key) return;
    var p = DATA[key];
    nav.dataset.naluDone = '1';

    var intro = document.createElement('div');
    intro.className = 'nalu-mm-intro';
    intro.innerHTML = '<p class="nalu-mm-intro__desc">' + esc(p.desc) + '</p>';
    nav.insertBefore(intro, nav.firstChild);

    if (!p.brands.length) return;
    var strip = document.createElement('div');
    strip.className = 'nalu-mm-brands';
    var html = '<span class="nalu-mm-brands__label">Brands in ' + esc(p.title) + '</span><ul class="nalu-mm-brands__list">';
    p.brands.forEach(function (b) {
      html += '<li><a href="/collections/' + b[1] + '">' + esc(b[0]) + '</a></li>';
    });
    html += '</ul><a class="nalu-mm-brands__all" href="/pages/brands">All brands →</a>';
    strip.innerHTML = html;
    nav.appendChild(strip);
  }

  function scan(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('.mega-menu__item--nav').forEach(enhance);
  }

  function start() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { scan(document); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Brand pages: breadcrumb "Collections" -> "Brands" */
(function () {
  function fix() {
    document.querySelectorAll('.collection-banner-section .breadcrumb a').forEach(function (a) {
      var p = a.getAttribute('href') || '';
      if (/\/collections\/?$/.test(p)) { a.setAttribute('href', '/pages/brands'); a.textContent = 'Brands'; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();
